import { ALLOCATION_GROUPS } from '../constants';
import { AbTests } from '../types';

/**
 * Returns a normalized experiment allocated group from the current user allocations.
 * @param {number|string} experimentId - the experiment id you want to check
 * @param {AbTests} abTests - in form of AbTests, either from RequestContext or from FiverrContext
 * @returns {number} - the allocated group
 */
export const getAllocatedGroup = (experimentId: number | string, abTests: AbTests = {}): number => {
    const allocatedGroup = abTests[experimentId];

    return Number(allocatedGroup) || ALLOCATION_GROUPS.NOT_ALLOCATED;
};
